import Cookies from 'js-cookie'
import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import PrivateRoute from '@/providers/private-routes'
// import { SearchProvider } from '@/context/search-context'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { Header } from '@/components/layout/header'
import { UniversalBreadcrumb } from '@/components/layout/universal-breadcrumb'
import { NotificationBell } from '@/components/notifications'
// import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
})

function RouteComponent() {
  const defaultOpen = Cookies.get('sidebar:state') !== 'false'

  const matches = useMatches()

  const isSpecialRoute = matches.some((match) =>
    [
      '/_authenticated/jobs/$jobId/assessments/create/ai',
      '/_authenticated/jobs/$jobId/assessments/create/from-template',
      '/_authenticated/jobs/$jobId/assessments/create/manual',
      '/_authenticated/jobs/$jobId/assessments/create/',
    ].includes(match.routeId)
  )
  return (
    <PrivateRoute>
      {/* <SearchProvider> */}
      {isSpecialRoute ? (
        <SidebarProvider defaultOpen={defaultOpen}>
          <SidebarInset>
            <Header>
              <UniversalBreadcrumb />
              <div className='ml-auto flex items-center space-x-4'>
                <NotificationBell />
                <ThemeSwitch />
              </div>
            </Header>
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      ) : (
        <SidebarProvider defaultOpen={defaultOpen}>
          <AppSidebar />
          <SidebarInset>
            <Header>
              <UniversalBreadcrumb />
              <div className='ml-auto flex items-center space-x-4'>
                {/* <Search /> */}
                <NotificationBell />
                <ThemeSwitch />
              </div>
            </Header>
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      )}
      {/* </SearchProvider> */}
    </PrivateRoute>
  )
}
